import React from 'react';
import { Link } from 'react-router-dom';
import { getEventsList } from "../../data/events";

const UpcomingEvents = () => {
    const events = getEventsList().slice(0, 3);

  return (
    <section className="bg-gray-100 py-16 px-8 text-center">
        <h2 className="text-4xl font-bold text-center text-custom-pink mb-6">CAMPUS HIGHLIGHTS</h2>
        <span className="inline-block border-solid  border-b-4 border-gold mb-4 w-28 h-2"></span>

      <div className="container mx-auto shadow-lg p-8 rounded-lg md:block hidden">
        <h2 className="text-3xl font-bold text-left text-custom-pink mb-12">Upcoming Events</h2>

        <div className="flex flex-col lg:flex-row flex-nowrap justify-center gap-8">
          {events.map((event, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg overflow-hidden w-full lg:w-[calc(33%-1rem)] relative flex flex-col"
            >
              <div className="relative overflow-hidden">
                <img
                  src={event.image}
                  alt={event.title}
                  className="w-full h-56 object-cover"
                />
                <p className="absolute top-0 left-0 bg-custom-pink text-white py-2 px-4 font-bold text-sm rounded-md shadow-md">
                  {event.date}
                </p>
              </div>
              <div className="flex-grow p-8 flex text-left flex-col justify-between">
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">{event.title}</h3>
                  <p className="text-gray-700 mb-6">{event.description}</p>
                </div>
                <Link
                  to={`/events/${event.id}`}
                  className="bg-custom-pink text-white w-full py-2 rounded-md border border-transparent hover:bg-transparent hover:text-custom-pink hover:border-custom-pink transition duration-300 mt-auto text-center hover:scale-105 hover:shadow-lg"
                >
                  SEE ALL ABOUT
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* See All Button */}
        <div className="text-center mt-12">
          <Link
            to="/events"
            className="bg-none text-custom-pink border border-custom-pink px-10 py-5 rounded-full hover:bg-custom-pink hover:text-white transition duration-300 inline-block"
          >
            SEE ALL EVENTS
          </Link>
        </div>
      </div>

      {/* Mobile version without container */}
      <div className="md:hidden px-4">
        <h2 className="text-2xl font-bold text-left text-custom-pink mb-8">Upcoming Events</h2>

        <div className="flex flex-col gap-6">
          {events.map((event, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg overflow-hidden w-full relative flex flex-col"
            >
              <div className="relative">
                <img
                  src={event.image}
                  alt={event.title}
                  className="w-full h-56 object-cover"
                />
                <p className="absolute top-0 left-0 bg-custom-pink text-white py-2 px-4 font-bold text-sm rounded-md shadow-md">
                  {event.date}
                </p>
              </div>
              <div className="flex-grow p-6 flex text-left flex-col justify-between">
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">{event.title}</h3>
                  <p className="text-gray-700 mb-6">{event.description}</p>
                </div>
                <Link
                  to={`/events/${event.id}`}
                  className="bg-custom-pink text-white w-full py-2 rounded-md border border-transparent hover:bg-transparent hover:text-custom-pink hover:border-custom-pink transition duration-300 mt-auto text-center hover:scale-105 hover:shadow-lg"
                >
                  SEE ALL ABOUT
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* See All Button */}
        <div className="text-center mt-8">
          <Link
            to="/events"
            className="bg-none text-custom-pink border border-custom-pink px-8 py-4 rounded-full hover:bg-custom-pink hover:text-white transition duration-300 inline-block text-sm"
          >
            SEE ALL EVENTS
          </Link>
        </div>
      </div>
    </section>
  );
};

export default UpcomingEvents;
